import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export function MainV2({
  collapsed,
  expandedWidth,
  collapsedWidth,
  children,
}: {
  collapsed: boolean;
  expandedWidth: string;
  collapsedWidth: string;
  children?: React.ReactNode;
}) {
  const theme = useTheme();
  /** True when the left nav behaves like a mobile overlay drawer instead of reserving page width. */
  const isMobileDrawerMode = useMediaQuery(theme.breakpoints.down("md"));
  const drawerWidth = collapsed ? collapsedWidth : expandedWidth;
  const width = isMobileDrawerMode ? "100%" : `calc(100% - ${drawerWidth})`;
  const marginLeft = isMobileDrawerMode ? 0 : drawerWidth;

  return (
    <Box
      data-testid="main-v2"
      data-nav-layout={isMobileDrawerMode ? "temporary" : "permanent"}
      data-nav-offset={typeof marginLeft === "number" ? `${marginLeft}px` : marginLeft}
      sx={{
        position: "relative",
        width,
        marginLeft,
        transition: theme.transitions.create(["margin", "width"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        ...(!collapsed &&
          !isMobileDrawerMode && {
            transition: theme.transitions.create(["margin", "width"], {
              easing: theme.transitions.easing.easeOut,
              duration: theme.transitions.duration.enteringScreen,
            }),
          }),
      }}
    >
      {children}
    </Box>
  );
}
